import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import {getMessage} from "../../util";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import React from "react";

const AnotherDevice = (props) => {

    return (<Dialog
        open={props.open}
        scroll="body"
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">{getMessage(props.meeting.meeting_type,'another_device_title',props.messages)}</DialogTitle>
        <DialogContent>
            <Typography id="alert-dialog-description">
                {getMessage(props.meeting.meeting_type,'another_device',props.messages)}
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button variant="outlined" onClick={props.handleClose} color="secondary" >
                {getMessage(props.meeting.meeting_type,'another_device_cancel',props.messages)}
            </Button>
            <Button variant="contained"  color="primary" autoFocus onClick={props.switchDevice}>
                {getMessage(props.meeting.meeting_type,'another_device_continue',props.messages)}
            </Button>
        </DialogActions>
    </Dialog>)
}

export default AnotherDevice;
